import { render, staticRenderFns } from "./ForumThreads.vue?vue&type=template&id=e82c757a&"
import script from "./ForumThreads.vue?vue&type=script&lang=js&"
export * from "./ForumThreads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports